import React from 'react'
import HelperButtonGroup from '../components/HelperButtonGroup'

/**
 * Controller component for Helper features
 * Manages the helper button group which now only contains chat-related features
 */
const HelperController: React.FC = () => {
  return <HelperButtonGroup />
}

export default HelperController
